import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import FocusIcon from "./FocusIcon";
import { IEssResidue } from "../types";

interface Props {
  essentialResidues: IEssResidue[] | null,
  disabled: boolean,
  focusResidue (essRes: IEssResidue): void,
}

export default function EssResSelect({essentialResidues, disabled, focusResidue}: Props) {

  const [selected, setSelected] = useState<IEssResidue | null>(null);

  const preselect = useCallback(() => {
    setSelected(essentialResidues?.[0] || null);
  }, [essentialResidues]);

  useEffect(() => {
    preselect();
  }, [preselect]);

  const handleChange = useCallback(e => {
    const key = e.target.value;
    const selected = essentialResidues?.find(er => er.key === key) ?? null;
    setSelected(selected);
    if (selected) {
      focusResidue(selected);
    }
  }, [essentialResidues, focusResidue]);

  const focusSelected = useCallback(() => {
    if (selected) focusResidue(selected);
  }, [selected, focusResidue]);

  return essentialResidues && essentialResidues.length > 0 ? <>
    <select
      style={{
        marginLeft: '5px',
        fontSize: '0.8em',
      }}
      value={selected?.key}
      onChange={handleChange}
      disabled={disabled}
    >
      {essentialResidues.map(r =>
        <option key={r.key} value={r.key}>{r.aminoAcid}{r.position}{r.mutatedAA}</option>
      )}
    </select>
    <FocusIcon
      disabled={disabled || !selected}
      title={`Focus ${selected ? `${selected.aminoAcid}${selected.position}` : 'essential residue'}`}
      focus={focusSelected}
    />
  </> : null;

}
